export default __webpack_public_path__ + "f21673f8d10cf0729cdd49b839d46dfc.svg";